export const Loading = ({ type = 'full' }: { type?: 'full' | 'partial' }) => {
  return <div>...</div>
}
